// extracted by mini-css-extract-plugin
module.exports = {"service-container":"Services_service-container__2Lu91","services":"Services_services__1IvjB"};